import { IS_PHONE_BROWSER } from 'reactApp/appHelpers/configHelpers';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { sendDwh } from 'reactApp/utils/ga';
import { ECategoryGa } from 'reactApp/utils/paymentGa';

export enum EPromoAction {
    SHOW = 'show',
    CLICK = 'click',
    CLOSE = 'close'
}

interface IShowPromo {
    action: EPromoAction.SHOW;
    /* В каком разделе показали плашку */
    source: EStorageType;
    /* Название плашки */
    name: 'disable-adv' | 'disable-adv-button' | 'antivirus';
}

interface IClickPromo {
    action: EPromoAction.CLICK;
    source: EStorageType;
    name: 'disable-adv' | 'disable-adv-button' | 'antivirus';
    /* Название кнопки/ссылки на которую нажали */
    name_button: 'disable-adv' | 'antivirus';
}

interface IClosePromo {
    action: EPromoAction.CLOSE;
    source: EStorageType;
    name: 'disable-adv' | 'disable-adv-button' | 'antivirus';
}

type IPromoAnalytics = IShowPromo | IClickPromo | IClosePromo;

export const sendSplashscreenAnalytics = ({ action, ...rest }: IPromoAnalytics): void => {
    const platform = IS_PHONE_BROWSER ? 'touch' : 'desktop';

    sendDwh({
        eventCategory: ECategoryGa.splashscreen_alert,
        action,
        dwhData: {
            platform,
            ...rest,
        },
    });
};
